import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const MedicalExpertiseIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.5 40C79.5 61.8153 61.8153 79.5 40 79.5C18.1848 79.5 0.5 61.8153 0.5 40C0.5 18.1848 18.1848 0.5 40 0.5C61.8153 0.5 79.5 18.1848 79.5 40Z'
    />
    <g clipPath='url(#clip0_414_17733)'>
      <path
        d='M46.8199 44.2215C46.8199 44.8914 46.5543 45.5034 46.1155 45.9538C45.6825 46.4042 45.0819 46.6929 44.4122 46.7159L41.1162 46.5926L41.5713 42.0794L42.0448 40.9419C42.1372 40.7283 42.3335 40.5666 42.5644 40.5146C42.6222 40.5031 42.6742 40.4973 42.7319 40.4973C43.0379 40.4973 43.3151 40.6878 43.4248 40.9939L43.6846 41.7618L44.1408 41.7329C45.5843 41.6232 46.8199 42.7665 46.8199 44.2215Z'
        fill='#F9C4C0'
      />
      <path
        d='M33.0667 52.6985V33.0732C33.0667 32.9282 33.0484 32.7883 33.0216 32.6514H30.8234V31.4866L30.7888 30.8706L20.8973 30.8489C19.1526 30.8489 17.7524 32.2548 17.7524 33.9962V52.6985H33.0667Z'
        fill='#78D7A6'
      />
      <path
        d='M32.8817 41.5917H33.2487V39.5238C33.2487 39.3417 33.3283 39.1675 33.4731 39.0335C33.8587 38.678 34.0795 38.1748 34.0795 37.6537C34.0795 37.1175 33.8616 36.6208 33.4659 36.256C33.324 36.1255 33.243 35.9477 33.243 35.7678V34.1006H32.876V35.7678C32.876 36.0502 33 36.3269 33.2172 36.5262C33.5361 36.8201 33.7125 37.2207 33.7125 37.6537C33.7125 38.0787 33.539 38.473 33.2236 38.764C33.0028 38.9683 32.8817 39.2385 32.8817 39.5238V41.5917Z'
        fill='#6675E9'
      />
      <path
        d='M27.7725 52.6986L28.1359 38.391C28.1857 36.43 27.3507 34.5506 25.8621 33.2731L23.0406 30.8518L20.2301 30.8455C18.4393 30.8455 16.9927 32.2921 16.9927 34.0829V52.6986H27.7725Z'
        fill='#F1F7FF'
      />
      <path
        d='M23.7561 43.2734C23.5795 43.2734 23.4051 43.2274 23.2474 43.1372C23.0088 43.001 22.8377 42.7799 22.7654 42.5146L22.2474 40.6148C22.0678 39.9554 22.1554 39.2652 22.4949 38.6716C22.834 38.0779 23.3843 37.6523 24.044 37.4723C24.7034 37.2935 25.3928 37.3807 25.9869 37.7198C26.5805 38.0589 27.0065 38.6092 27.1861 39.269L27.7041 41.1687C27.8529 41.7161 27.529 42.2827 26.9824 42.4318C26.7813 42.4875 26.5709 42.3684 26.5156 42.1654C26.4603 41.9628 26.5798 41.7539 26.782 41.6986C26.9253 41.6597 27.0099 41.5112 26.9709 41.368L26.4529 39.4686C26.3264 39.0048 26.0269 38.6181 25.6099 38.3795C25.1928 38.1409 24.7067 38.0786 24.2436 38.2055C23.7798 38.332 23.3932 38.6315 23.1546 39.0485C22.916 39.466 22.8541 39.9513 22.9806 40.4151L23.4986 42.3149C23.5175 42.3843 23.562 42.4418 23.6244 42.4775C23.6871 42.5134 23.7602 42.5227 23.8281 42.5034C24.0318 42.4474 24.2399 42.5672 24.2949 42.7698C24.3501 42.9724 24.2307 43.1813 24.0284 43.2366C23.9383 43.2611 23.847 43.2734 23.7561 43.2734Z'
        fill='#5592FF'
      />
      <path
        d='M17.9944 52.6986C18.1321 51.5304 18.4317 50.3806 18.9683 49.3333C19.6183 48.0523 20.638 46.9371 21.9253 46.2998C23.6652 45.4458 25.6917 45.5223 27.6227 45.6306V44.5026C26.6285 44.4325 25.6598 44.2477 24.7931 43.7761C23.5186 43.0751 22.6327 41.8196 21.9763 40.5195C21.3199 39.2195 20.8356 37.8302 20.0899 36.5747C19.733 35.9629 19.2104 35.3256 18.4967 35.2938C17.9104 35.2619 17.4006 35.6634 16.9927 36.1031V52.6986H17.9944Z'
        fill='#C7DAFA'
      />
      <path d='M27.759 30.8594L28.3189 33.7375L23.1841 30.8594H27.759Z' fill='#F9C4C0' />
      <path
        d='M29.3174 44.888C29.9194 46.2259 31.3376 47.0019 32.7891 46.7746L41.1142 46.5947L41.5702 42.0777L35.5986 41.1354L35.3578 35.6472C35.1975 33.1557 33.2128 31.161 30.7886 30.8704C30.5834 30.8458 30.4237 30.8691 30.2122 30.8691L29.3174 44.888Z'
        fill='#F1F7FF'
      />
      <path
        d='M29.6556 36.8221L29.5657 52.6985H33.8999V35.0706C33.8999 33.0617 33.9108 31.1479 30.2124 30.8692C29.9425 30.8488 28.978 30.8278 28.2158 30.8488C28.2158 30.8488 29.624 33.3663 29.8001 34.299C29.9173 34.9199 29.6556 36.8221 29.6556 36.8221Z'
        fill='#F1F7FF'
      />
      <path
        d='M30.389 46.3764C31.3602 46.9012 32.0659 47.8242 32.4581 48.8436C32.9236 50.0649 32.9959 51.3904 33.0234 52.6986H33.8998V44.7719C32.8441 44.1807 31.5894 43.9756 30.4855 44.428C30.0331 44.615 29.5204 44.989 29.5264 45.5319C29.5385 46.0205 30.021 46.1834 30.389 46.3764Z'
        fill='#C7DAFA'
      />
      <path
        d='M23.5538 40.8026C23.5538 40.8026 22.1525 33.8738 20.6007 30.846L20.5893 30.8455C18.871 30.7666 16.9406 32.0501 16.9922 33.7694V38.9022L18.7497 42.9785C19.1404 44.3928 20.4276 45.372 21.8949 45.3711L31.1737 45.7477V41.0782L23.5538 40.8026Z'
        fill='#F1F7FF'
      />
      <path d='M33.7124 38.0188H34.0924V46.7799H33.7124V38.0188Z' fill='#CDCCCC' />
      <path
        d='M31.1214 41.2254L31.1386 40.8584L23.9257 40.464L22.4829 35.6455L22.1826 35.7315L23.69 40.8181L31.1214 41.2254Z'
        fill='#C7DAFA'
      />
      <path
        d='M31.166 41.2268L32.8803 41.59L33.3838 41.3479C33.6833 41.2077 33.8044 40.8444 33.6451 40.5513C33.5431 40.3537 33.3392 40.2454 33.1353 40.2454C33.0397 40.2454 32.9441 40.2645 32.8549 40.3155L31.166 41.2268Z'
        fill='#F9C4C0'
      />
      <path
        d='M31.166 41.2271L31.1724 45.7454H34.2187C35.4104 45.7454 36.36 44.7449 36.2899 43.5531C36.258 43.0051 36.0158 42.508 35.6462 42.1575C35.2766 41.807 34.7667 41.5903 34.2187 41.5903H32.8803L31.166 41.2271Z'
        fill='#F9C4C0'
      />
      <path d='M20.0771 52.5728H25.408V52.6989H20.0771V52.5728Z' fill='#C7DAFA' />
      <path
        d='M65 54.0481H15L16.4531 48.4856C16.5156 48.2252 16.75 48.0481 17.0156 48.0481H62.9896C63.2552 48.0481 63.4844 48.2252 63.5521 48.4856L65 54.0481Z'
        fill='#387094'
      />
      <path
        d='M65 54.0483V55.7983C65 56.1212 64.7396 56.3817 64.4167 56.3817H15.5833C15.2604 56.3817 15 56.1212 15 55.7983V54.0483H65Z'
        fill='#315A79'
      />
      <path
        d='M63.9912 64.4301V49.2668C63.9912 47.9552 63.3602 46.7976 62.3865 46.0672C62.3865 46.0622 62.3815 46.0622 62.3815 46.0622C61.7157 45.5704 60.896 45.2773 60.0017 45.2773H59.5347V64.4301H63.9912Z'
        fill='#79AFFE'
      />
      <path d='M63.0815 64.4302L62.8066 49.5635H62.514L61.8213 64.4302H63.0815Z' fill='#F97D00' />
      <path
        d='M55.8781 41.2979V45.4165L55.7588 45.4463L51.2278 46.5294L51.2476 44.7855L51.2278 44.4725L51.188 43.8316L51.1532 43.2702L51.0738 42.0182L50.9595 41.2979H55.8781Z'
        fill='#F9C4C0'
      />
      <path
        d='M53.7964 42.4157C53.7964 42.4157 52.4997 43.6628 51.188 43.8316L51.1532 43.2702L51.0738 42.0182L50.9595 41.2979H53.1406L53.7964 42.4157Z'
        fill='#FD9997'
      />
      <path
        d='M37.2342 49.531L35.3512 52.7665L33.6098 51.4154C33.2395 51.1251 33.0293 50.6848 33.0293 50.2344C33.0293 50.0793 33.0543 49.9242 33.1043 49.7741C33.3796 48.9334 34.3153 48.513 35.126 48.8683L35.8666 49.1886L35.7014 48.6682C35.6864 48.6231 35.6814 48.5831 35.6814 48.538C35.6814 48.3979 35.7465 48.2628 35.8616 48.1778C36.0817 48.0226 36.392 48.0927 36.5121 48.3329L37.2342 49.531Z'
        fill='#F9C4C0'
      />
      <path
        d='M45.0511 45.2773C43.9719 45.2773 42.9899 45.9015 42.5318 46.8787L40.6011 51.5063L37.2359 49.5322C36.4407 49.5199 34.8262 51.759 35.3531 52.7688L39.9374 57.359C41.265 58.6883 43.414 58.7054 44.7625 57.3973L47.1725 55.0596L45.0511 45.2773Z'
        fill='#79AFFE'
      />
      <path
        d='M62.3867 46.0672C62.3867 46.0622 62.3818 46.0622 62.3818 46.0622C61.716 45.5704 60.8963 45.2773 60.002 45.2773H45.0513V64.4301H62.5159V46.6535C62.5159 46.4399 62.4713 46.2412 62.3867 46.0672Z'
        fill='#79AFFE'
      />
      <path
        d='M56.5191 36.5232V39.3502C56.5191 41.5163 54.7653 43.2702 52.5992 43.2702C50.6864 43.2702 49.0965 41.9039 48.7487 40.0904C48.709 39.8768 48.6842 39.6532 48.6792 39.4297V36.5232C48.6792 34.362 50.433 32.6033 52.5992 32.6033C53.6823 32.6033 54.661 33.0454 55.3715 33.7509C56.0819 34.4614 56.5191 35.4401 56.5191 36.5232Z'
        fill='#F9C4C0'
      />
      <path
        d='M56.6442 41.8231C57.8483 40.4638 59.5333 37.25 59.5333 35.615C59.5333 33.1962 56.7679 32.2637 55.1459 32.2637C53.5239 32.2637 52 35.4319 52 37.8507C52 38.6078 52.0667 39.6376 52.2404 40.5296C52.4791 41.7548 53.5877 42.6668 54.8331 42.5822C55.5634 42.5325 56.2604 42.2796 56.6442 41.8231Z'
        fill='#363383'
      />
      <path
        d='M52.0003 36.6164C49.3527 36.6164 47.0996 34.7691 47.0996 32.9931C47.0996 31.2117 49.2515 29.7734 51.8991 29.7734C54.5522 29.7734 58.145 31.7096 58.145 33.4911C58.145 35.267 54.6534 36.6164 52.0003 36.6164Z'
        fill='#363383'
      />
      <path
        d='M48.6792 36.7004C48.8227 36.7004 48.9352 36.9518 48.9352 37.2616C48.9352 37.567 48.8227 37.8183 48.6792 37.8183'
        fill='#242C3F'
      />
      <path
        d='M51.7912 39.0765C52.3603 39.0765 52.8216 38.4522 52.8216 37.682C52.8216 36.9119 52.3603 36.2876 51.7912 36.2876C51.2221 36.2876 50.7607 36.9119 50.7607 37.682C50.7607 38.4522 51.2221 39.0765 51.7912 39.0765Z'
        fill='#F9C4C0'
      />
      <path
        d='M51.5562 35.846L50.96 38.8021C50.6271 38.8021 50.3638 38.5338 50.3638 38.2059V35.846C50.3638 35.5181 50.6271 35.2498 50.96 35.2498C51.2929 35.2498 51.5562 35.5181 51.5562 35.846Z'
        fill='#363383'
      />
      <path
        d='M56.4791 45.2775H50.8408C50.8408 44.8718 51.1697 44.543 51.5753 44.543H55.7447C56.1503 44.543 56.4791 44.8718 56.4791 45.2775Z'
        fill='#DDEAF7'
      />
      <path d='M48.2886 51.6775H48.7848V64.4297H48.2886V51.6775Z' fill='#F97D00' />
      <path
        d='M64.3084 64.6348H46.7095V53.4555C46.7095 51.3305 48.4321 49.6079 50.5571 49.6079H60.4608C62.5858 49.6079 64.3084 51.3305 64.3084 53.4555V64.6348Z'
        fill='#F99072'
      />
      <path
        d='M64.9998 64.6345H47.4009V53.4553C47.4009 51.3303 49.1235 49.6077 51.2485 49.6077H61.1522C63.2772 49.6077 64.9998 51.3303 64.9998 53.4553V64.6345Z'
        fill='#FCBA97'
      />
      <path
        d='M20.9711 30.8592H30.1887C30.2202 30.78 31.4978 27.5682 32.184 25.48C32.8734 23.3601 32.6903 18.3649 30.0026 16.7016C27.315 15.0329 26.2539 16.8647 26.2539 16.8647C20.7117 14.4404 20.1031 23.4253 20.8571 25.6049L20.9711 30.8592Z'
        fill='#333077'
      />
      <path
        d='M22.5671 31.062C22.4884 31.062 22.4094 31.0379 22.3411 30.9874C22.1726 30.8624 22.1374 30.6246 22.2621 30.4557C22.7745 29.7644 23.5622 29.3682 24.4234 29.3682H26.0142C26.9481 29.3682 27.8468 29.7099 28.5455 30.3303C28.7024 30.4698 28.7165 30.7099 28.5774 30.8669C28.4371 31.0238 28.1974 31.0379 28.0409 30.8988C27.4813 30.4015 26.7618 30.1281 26.0142 30.1281H24.4234C23.8053 30.1281 23.2402 30.4123 22.8728 30.9084C22.7982 31.009 22.6836 31.062 22.5671 31.062Z'
        fill='#5592FF'
      />
      <path d='M23.1841 25.3916H27.7444V30.8592H23.1841V25.3916Z' fill='#F9C4C0' />
      <path
        d='M27.7442 24.4519L27.7442 28.7035C27.7442 28.7035 25.7281 29.7458 23.1841 29.355L23.1841 24.4519L27.7442 24.4519Z'
        fill='#FD9997'
      />
      <path
        d='M31.1642 22.3411V25.0853C31.1642 27.287 29.3826 29.0739 27.1756 29.0739C24.9739 29.0739 23.187 27.287 23.187 25.0853V22.3411C23.187 20.1395 24.9739 18.3525 27.1756 18.3525C28.2765 18.3525 29.2763 18.7993 29.9995 19.5226C30.7175 20.2458 31.1642 21.2403 31.1642 22.3411Z'
        fill='#F9C4C0'
      />
      <path
        d='M29.6316 24.1675C29.8373 24.1675 30.004 23.9439 30.004 23.6682C30.004 23.3925 29.8373 23.1689 29.6316 23.1689C29.426 23.1689 29.2593 23.3925 29.2593 23.6682C29.2593 23.9439 29.426 24.1675 29.6316 24.1675Z'
        fill='#242C3F'
      />
      <path
        d='M26.9329 24.1675C27.1386 24.1675 27.3053 23.9439 27.3053 23.6682C27.3053 23.3925 27.1386 23.1689 26.9329 23.1689C26.7273 23.1689 26.5605 23.3925 26.5605 23.6682C26.5605 23.9439 26.7273 24.1675 26.9329 24.1675Z'
        fill='#242C3F'
      />
      <path
        d='M26.7307 25.9119C26.7297 25.9339 26.7241 25.9545 26.7241 25.9767C26.7241 26.8123 27.4015 27.4897 28.2371 27.4897C29.0726 27.4897 29.75 26.8123 29.75 25.9767C29.75 25.9545 29.7444 25.9339 29.7435 25.9119H26.7307Z'
        fill='white'
      />
      <path
        d='M21.8574 24.4518C21.8574 25.186 22.451 25.781 23.1844 25.7846V23.1189C22.451 23.1226 21.8574 23.7175 21.8574 24.4518Z'
        fill='#F9C4C0'
      />
      <path
        d='M23.187 21.6498C23.187 21.6498 29.144 22.1973 31.0058 21.2294C32.8676 20.2614 31.0058 18.6682 31.0058 18.6682L29.4536 17.9854L25.8574 17.075L23.187 17.9854V21.6498Z'
        fill='#333077'
      />
      <path
        d='M47.9937 18.776V27.4006C47.9937 27.5175 47.8989 27.6124 47.7819 27.6124H38.5857C38.5406 27.6124 38.4966 27.6268 38.4602 27.6536L36.8748 28.8204C36.7349 28.9234 36.5374 28.8235 36.5374 28.6499V27.8242C36.5374 27.7072 36.4426 27.6124 36.3256 27.6124H35.3593C35.2423 27.6124 35.1475 27.5175 35.1475 27.4006V18.776C35.1475 18.659 35.2423 18.5642 35.3593 18.5642H47.7819C47.8989 18.5642 47.9937 18.659 47.9937 18.776Z'
        fill='#F1F7FF'
      />
      <path
        d='M39.8114 23.0737C39.8114 23.509 39.4572 23.8631 39.0292 23.8631C38.5939 23.8631 38.2397 23.509 38.2397 23.0737C38.2397 22.6457 38.5939 22.2915 39.0292 22.2915C39.4572 22.2915 39.8114 22.6457 39.8114 23.0737Z'
        fill='#C7DAFA'
      />
      <path
        d='M42.3563 23.0737C42.3563 23.509 42.0021 23.8631 41.5741 23.8631C41.1388 23.8631 40.7847 23.509 40.7847 23.0737C40.7847 22.6457 41.1388 22.2915 41.5741 22.2915C42.0021 22.2915 42.3563 22.6457 42.3563 23.0737Z'
        fill='#C7DAFA'
      />
      <path
        d='M44.9007 23.0737C44.9007 23.509 44.5465 23.8631 44.1186 23.8631C43.6833 23.8631 43.3291 23.509 43.3291 23.0737C43.3291 22.6457 43.6833 22.2915 44.1186 22.2915C44.5465 22.2915 44.9007 22.6457 44.9007 23.0737Z'
        fill='#C7DAFA'
      />
      <path
        d='M30.9484 37.89L28.8853 32.1468C28.7132 31.6678 28.4211 31.2363 28.0412 30.8982C27.8842 30.7591 27.8701 30.519 28.0096 30.3621C28.1484 30.2047 28.3889 30.1899 28.5458 30.3305C29.0208 30.752 29.3851 31.2916 29.6007 31.8897L31.6638 37.6332C31.7347 37.8306 31.6319 38.0484 31.4345 38.1193C31.2397 38.1894 31.02 38.0896 30.9484 37.89Z'
        fill='#5592FF'
      />
      <path
        d='M23.6583 37.89L21.8903 32.9695C21.5856 32.1205 21.7244 31.1806 22.2624 30.4556C22.3871 30.2871 22.6264 30.2523 22.7938 30.3769C22.9622 30.5016 22.9975 30.7398 22.8724 30.9083C22.4865 31.4289 22.3867 32.1035 22.6056 32.7127L24.3737 37.6333C24.4446 37.8307 24.3418 38.0481 24.1444 38.1194C23.9496 38.1894 23.73 38.0896 23.6583 37.89Z'
        fill='#5592FF'
      />
      <path
        d='M32.7705 39.0203C33.2469 38.4241 33.0692 37.4902 32.3737 36.9345C31.6781 36.3788 30.7281 36.4116 30.2517 37.0078C29.7753 37.6041 29.953 38.5379 30.6486 39.0936C31.3441 39.6494 32.2941 39.6165 32.7705 39.0203Z'
        fill='#5592FF'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_17733'>
        <rect width='50' height='50' fill='white' transform='translate(15 15)' />
      </clipPath>
    </defs>
  </svg>
));
MedicalExpertiseIcon.displayName = 'MedicalExpertiseIcon';

export default MedicalExpertiseIcon;
